import React from "react";
import styled, { keyframes } from "styled-components";
import {
  LoadingOutlined,
  RobotOutlined,
  SearchOutlined,
} from "@ant-design/icons"; // Import the RobotOutlined icon from Ant Design Icons

const loaderAnimation = keyframes`
  0%, 20% {
    transform: scale(1);
  }

  50% {
    transform: scale(1.5);
  }

  100% {
    transform: scale(1);
  }
`;

const LoaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  font-size: 1.5rem;
  color: #282c34;
  height: inherit;
`;

const LoaderText = styled.div`
  /* margin-top: 10px; */
  font-size: 2rem;
  font-weight: bold;
`;

const LoaderAnimation = styled.div`
  display: flex;
  margin-top: 10px;
`;

const Dot = styled.div`
  width: 15px;
  height: 15px;
  background-color: #282c34;
  border-radius: 50%;
  margin: 0 8px;
  animation: ${loaderAnimation} 1s infinite;

  &:nth-child(2) {
    animation-delay: 0.3s;
  }

  &:nth-child(3) {
    animation-delay: 0.6s;
  }
`;

const Loader = ({ LoadingText }) => {
  return (
    <LoaderContainer>
      <LoadingOutlined style={{ fontSize: "4rem", marginBottom: "10px" }} />
      <LoaderText>{LoadingText}</LoaderText>
      <LoaderAnimation>
        <Dot />
        <Dot />
        <Dot />
      </LoaderAnimation>
    </LoaderContainer>
  );
};

export default Loader;
